export enum ActionsButtonsEnum {
    EDIT = "edit",
    CLONE = "clone",
    DELETE = "delete",
}
